var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-calendar-filter"},[_c('date-picker',{attrs:{"type":"date","range":"","placeholder":_vm.placeHolder,"disabled-date":_vm.disabledDates,"shortcuts":_vm.shortcuts},model:{value:(_vm.pickedDate),callback:function ($$v) {_vm.pickedDate=$$v},expression:"pickedDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }